import logo from './logo.svg';
import { Route, Routes, BrowserRouter } from 'react-router-dom';
import './App.css';
import Home from './pages/Home';

function App() {
  return (
    <div className="App">
     <BrowserRouter>
        <Routes>
          <Route path = "/" element={<Home/>}/>
        </Routes>
     </BrowserRouter>
    </div>
  );
}

export default App;
